<template>
  <div class="second-layout">
    <highlight-container even :title="section1.title">
      <v-container a-0 fluid ma-0>
        <v-row align="center" ma-0>
          <v-col align="center" class="pa-0" cols="12" md="5">
            <v-img contain class="section1-image ma-0" :src="section1.image" />
          </v-col>
          <v-col
            :align="$vuetify.breakpoint.smAndDown ? 'center' : 'start'"
            class="px-0"
            cols="12"
            md="6"
            offset-md="1"
            xs="12"
          >
            <p
              class="text-justify text-md-left ma-0 mb-md-7 text-body"
              v-html="section1.text"
            />
          </v-col>
        </v-row>
      </v-container>
    </highlight-container>
    <highlight-container
      :title="section2.title"
      :subtitle="section2.description"
    >
      <v-carousel class="height-arrow-greenprint" hide-delimiters height="auto">
        <v-carousel-item
          v-for="(slide, i) in section2.slides"
          :key="i"
          eager
          class="text-body"
        >
          <v-container
            fluid
            class="padding-carousel"
            @mouseenter="createAnalyticsEvent()"
          >
            <v-row>
              <v-col cols="12" md="3" align="center">
                <v-img :src="slide.image" max-width="200px" />
              </v-col>
              <v-col cols="12" md="9" class="pr-md-10">
                <v-row>
                  <v-col cols="12">
                    <p class="ma-0">
                      {{ slide.text }}
                    </p>
                    <div v-if="slide.listString" class="mt-3">
                      <p
                        v-for="(item, x) in slide.listString"
                        :key="x"
                        class="mb-1"
                      >
                        <v-img
                          :src="
                            require('@/assets/images/materialicons/circle-medium.svg')
                          "
                          contain
                          width="24"
                          class="d-inline-block"
                          style="vertical-align: middle"
                        />
                        {{ item }}
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-carousel-item>
      </v-carousel>
    </highlight-container>
    <highlight-container
      v-if="
        $store.state.persona.selected.id === 1 ||
        $store.state.persona.selected.id === 2
      "
      class="pb-0"
      even
      :title="section3.title"
      :subtitle="section3.description"
    >
      <HubspotForm
        form-id="19018252-6850-4b57-bd3e-08eb1a190bd7"
        :on-form-submit="
          () => {
            this.$analytics(
              'Formulário',
              'sent-B2B ',
              $store.state.persona.selected.id === 1
                ? 'empreendedores-ogreenprint'
                : 'corporacoes-ogreenprint',
            );
          }
        "
      />
      <!-- <greenprint-contact
        :event-label="
          $store.state.persona.selected.id === 1
            ? 'empreendedores-ogreenprint'
            : 'corporacoes-ogreenprint'
        "
      /> -->
    </highlight-container>
  </div>
</template>

<script>
export default {
  name: 'Greenprint',
  components: {
    HighlightContainer: () => import('@/components/HighlightContainer.vue'),
    HubspotForm: () => import('@/components/HubspotForm.vue'),
    // GreenprintContact: () => import('@/components/Forms/GreenprintContact.vue'),
  },
  data() {
    return {
      createEventTrue: false,
      section1: {
        image: require('@/assets/images/greenprint/secao1.png'),
        title: 'Que tal deixar uma pegada <br> mais positiva no mundo?',
        text: `A reciclagem é um dos principais meios de reentrada das embalagens no ciclo da Economia Circular.
              Os recicladores usam materiais pós-consumo (que foram comercializados) e pós-industriais (que são
              refugos da produção) como matéria prima. Quanto mais as empresas dão preferência para o material
              reciclado de origem pós-consumo, mais elas ajudam a desenvolver a cadeia circular e a diminuir os
              resíduos que vão para o aterro. O objetivo da eu<b>reciclo</b> é aumentar as taxas de reciclagem. Para
              encontrar soluções e ampliar o impacto, acreditamos muito no trabalho colaborativo.`,
      },
      section2: {
        title: 'Greenprint: Solução customizada, <br> impactos efetivos',
        description: `O Greenprint foi criado para oferecer às empresas soluções personalizadas conforme suas demandas,
                     objetivos ou ações já desenvolvidas internamente. Nosso time de especialistas é responsável por
                     desenhar a estratégia em colaboração com sua empresa, usando nossa capacidade tecnológica, big data
                     e conectando os atores da cadeia.`,
        slides: [
          {
            title: 'Rastreamento da economia circular: Garantia da origem',
            text: `Nós aplicamos o rastreamento a partir do reciclador até a origem do material, para identificar a
                  origem pós-consumo. Isso resulta em transparência na cadeia e confiabilidade para suportar as metas e
                  claims da empresa. A demanda por material reciclado pós-consumo impacta positivamente toda a cadeia,
                  para que a separação e reciclagem de outros materiais se torne viável e escalável como no caso do alumínio.`,
            image: require('@/assets/images/greenprint/section2Image3.png'),
          },
          {
            title: 'Mapeamento e estruturação da rede de material reciclado',
            text: `Mapeamos centrais de triagem com capacidade e especificação de material, além de oferecermos apoio
                  para acordo entre as partes e certificação do material. Os casos que acompanhamos se basearam na relação
                  ganha-ganha. A colaboração entre atores da cadeia proporciona, de um lado, a confiabilidade do
                  fornecimento de material, e do outro, a garantia de comercialização frequente e justa.`,
            image: require('@/assets/images/greenprint/section2Image2.png'),
          },
          {
            title: 'Busca por adicionalidade na cadeia de reciclagem',
            text: `Você e sua empresa são agentes de transformação da economia circular e da reciclagem. Diferentes
                  estratégias podem ser adotadas, e cada tipo de iniciativa cumpre um papel diferente e tem efetividades
                  distintas. Como aumentar a capacidade de triagem e reciclagem? Alguns exemplos são:`,
            image: require('@/assets/images/greenprint/section2Image1.png'),
            listString: [
              'Melhorar a produtividade da operação atual',
              'Aumentar a capacidade total (turno extra, equipamento)',
              'Tornar economicamente viável a cadeia de um material que hoje vai para o rejeito',
              'Nova operação semi-mecanizada ou mecanizada',
              'Contratos de longo prazo para fornecimento de material e/ou de certificados de reciclagem',
              'Arquitetura de investimento em capacidade futura com contrapartida em material e/ou certificados',
            ],
          },
        ],
      },
      section3: {
        title: 'Vamos colaborar?',
        description: `Estudamos soluções para as cadeias dos materiais e temos parcerias com operadores de reciclagem
                     em 22 estados. Entre em contato com nossos especialistas e saiba como o Greenprint pode se aplicar
                     na sua empresa.`,
      },
    };
  },
  methods: {
    createAnalyticsEvent() {
      if (!this.createEventTrue) {
        const elementPrev = document.getElementsByClassName('v-window__prev');
        elementPrev[0].addEventListener('click', () =>
          this.$analytics('solução-customizada-impactos-efetivos', 'voltar'),
        );

        const elementNext = document.getElementsByClassName('v-window__next');
        elementNext[0].addEventListener('click', () =>
          this.$analytics('solução-customizada-impactos-efetivos', 'avançar'),
        );

        this.createEventTrue = true;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.section1-image
  margin-top: 0
  max-width: 500px
  @media screen and (max-width: $sm)
    margin-top: 25px
    max-height: none
  @media screen and (max-width: $xs)
    margin-top: 25px
    max-height: none
.contact-button
  width: 40%
  @media screen and (max-width: $xs)
    width: 100%

.text-body
  color: rgba(0, 0, 0, 0.87)

.new-color
  .text-body
    color: rgba(0, 48, 54, 0.87)
</style>

<style lang="sass">
@import '@/styles/util'

.height-arrow-greenprint
  .v-window__next, .v-window__prev
    top: 130px
    @media screen and (max-width: $xs)
      top: 110px

.v-carousel
  .v-window__next
    .v-btn__content
      .v-icon
        background: url('/images/chevron-right.svg') center
        background-size: 36px


  .v-window__prev
    .v-btn__content
      .v-icon
        background: url('/images/chevron-left.svg') center
        background-size: 36px
</style>
